// import React, { useEffect, useState } from "react";
// import img2 from "../../assets/images/smalladhaar.jpeg";
// import img3 from "../../assets/images/signImg.png";
// import { getBase64 } from "../../Functions/Utils";
// import { ManageApis } from "../../AppServices/ManageApi";
// import AlertBox from "../../Components/AlertBox/AlertBox";
// import Loader from "../../Components/LoaderComponent/Loader";

// function SignatureCrop() {
//   const [isLoading, setisLoading] = useState(false);
//   const [uploadFileData, setUploadFileData] = useState({
//     primaryFile: "",
//     secondryFile: "",
//   });
//   const [responseFileData, setResponseFileData] = useState({
//     primaryFile: "",
//     secondryFile: "",
//     matchScore:""
//   });
//   const AlertinitialValue = {
//     show: false,
//     message: "",
//     isfalse: false,
//     isSuccess: false,
//   };
//   const [showAlert, setShowAlert] = useState(AlertinitialValue);

//   let headers = {
//     headers: {
//       "Access-Control-Allow-Origin": "*",
//       "Content-Type": "application/json",
//       Key: "aasdapld7!!458856akspksiklsjj-sklsp@#sjkdkldi",
//     },
//   };

// useEffect(() => {
//   // //console.log(responseFileData)
// }, [responseFileData])


//   const handleFileUpload = async (event, type) => {
//     setisLoading(true);
//     const file = event.target.files[0];
//     const imgtype = file?.type?.split("/").pop();
//     // if (!file) return console.error("No file selected.");

//     try {
//       const base64Data = await getBase64(file);
//       if (type === "primaryFile") {
//         setUploadFileData((prevData) => ({
//           ...prevData,
//           primaryFile: base64Data,
//         }));
//         let result = await getCropSignatue(base64Data, imgtype);
//         if (result.message == "Success") {
//           setResponseFileData((prevData) => ({
//             ...prevData,
//             primaryFile:  result.response_data?.response,
//           }));
//           setisLoading(false);
//         } else {
//           // //console.log(result);
//           setisLoading(false);
//           setShowAlert((pre) => ({
//             ...pre,
//             show: true,
//             message: result.message,
//             isSuccess: false,
//             isfalse: true,
//           }));
//         }
//       } else if (type === "secondryFile") {
//         setUploadFileData((prevData) => ({
//           ...prevData,
//           secondryFile: base64Data,
//         }));
//         let result = await getCropSignatue(base64Data, imgtype);
//         if (result.message == "Success") {
//           setResponseFileData((prevData) => ({
//             ...prevData,
//             secondryFile: result.response_data?.response,
//           }));

//           setisLoading(false);
//         } else {
//           setShowAlert((pre) => ({
//             ...pre,
//             show: true,
//             message: result.message,
//             isSuccess: false,
//             isfalse: true,
//           }));
//           // //console.log(result);
//           setisLoading(false);
//         }
//       } else {
//         // console.error("Invalid file type.");
//         setisLoading(false);
//       }
//     } catch (error) {
//       setisLoading(false);
//       // console.error("Error converting file to base64:", error);
//     }
//   };
//   //   const rqstData={
//   // image1: {
//   //     image: detectBaseSignature,
//   //     image_format: baseSignatureImageType,
//   //     image_uuid:123
//   //   },
//   //   image2: {
//   //     image: detectCompareSignature,
//   //     image_format:compareSignatureImageType,
//   //     image_uuid: 123
//   //   }
//   // }

//   async function getCropSignatue(base64, fileType) {
//     let response = null;
//     try {

//       var reqstDta = {
//         image: {
//           image: base64,
//           image_format: fileType,
//           image_uuid: "123",
//         },
//         output_option: {
//           output_option: "signatures",
//         },
//       };
//       response = await ManageApis(
//         "post",
//         global.signVerify + global.detectSign,
//         reqstDta,
//         headers
//       );
//     } catch (err) {
//       // console.error(err);
//     }

//     return response;
//   }



//   const handleMatchScore = async()=>{
//     try{
//       setisLoading(true);
//     const rqstData={
//       image1: {
//         image: responseFileData?.primaryFile,
//         image_format: "png",
//         image_uuid:123
//       },
//       image2: {
//         image: responseFileData.secondryFile,
//         image_format:"png",
//         image_uuid: 123
//       }
//     }

//     let response = await ManageApis(
//       "post",
//       global.signVerify + global.verifySign,
//       rqstData,
//       headers
//     );

//     if(response.message ==="Success"){
//       // //console.log(response.response_data)

//       setResponseFileData((prevData) => ({
//         ...prevData,
//         matchScore: response?.response_data,
//       }));


//       setisLoading(false);
//     }else{
//       setShowAlert((pre) => ({
//         ...pre,
//         show: true,
//         message: "Something went wrong...!",
//         isSuccess: false,
//         isfalse: true,
//       }));
//       // //console.log(response);
//       setisLoading(false);
//     }

//   } catch (err) {
//     setisLoading(false);
//     // console.error(err);
//   }
//   }
//   return (
//     <>
//       {isLoading && <Loader />}
//       <AlertBox
//         show={showAlert.show}
//         message={showAlert.message}
//         enableFailIcon={showAlert.isfalse}
//         enableSuccessIcon={showAlert.isSuccess}
//         handlecancel={() => setShowAlert(AlertinitialValue)}
//       />
//       <div className="signatureCrop d-flex flex-column justify-content-between overflow-auto scrollbar1">
//        <div className="d-block d-md-flex">
//       <div className={`border border-2 bd_gray2 ms-0 ms-md-3 w-100 p-3 pt-0 rounded `}>
//         <div className="row gap-3 gap-sm-0">

//             {["primaryFile","secondryFile"].map((itm,index)=>(
//         <div key={index} className="col-12 col-sm-6 br_1">
//         <div className={`bg_gray2 d-flex w-100 rounded ${uploadFileData[itm]?"d-none":"" } upload_box`}>
//           <div className=" m-auto">
//             <h2 className="font_13 font_600 text-center mb-3">
//               Please upload a document
//             </h2>
//             <div className=" bg_gray2 rounded p-2">

//             </div>

//            { <div className="d-flex align-items-center justify-content-center">
//               <label className="UploadLabel bg_master_gradient px-5 py-2 font_12 font_600 text-white border outline rounded-pillbg_master_gradient px-5 py-2 font_12 font_600 text-white border outline rounded-pill cursor-pointer">
//                 Upload
//                 <input
//                   accept={".jpeg,.jpg,.png"}
//                   type="file"
//                   className="d-none"
//                   onChange={(e) => handleFileUpload(e,itm)}
//                 />
//               </label>
//             </div>}
//           </div>
//         </div>


//         <div className={` ${uploadFileData[itm]?"": "d-none"}  ` }>
//         <div className="row">
//           <div className="col-md-6">
//             <h2 className="py-2 py-sm-3 mb-0 text-uppercase font_13 fw-bold ws_nowrp text_master2 text-center">
//               UPLOADED DATA
//             </h2>
//             <div className=" bg_gray2 rounded p-2">
//               <img
//                 src={uploadFileData[itm]}
//                 loading="lazy"
//                 className="w-100 rounded object_fit_contain UploadSignExtractImg"
//               />
//             </div>
//           </div>
//           <div className="col-md-6">
//             <h2 className="py-2 py-sm-3 mb-0 text-uppercase font_13 fw-bold ws_nowrp text_master2 text-center">
//               EXTRACTED SIGNATURE
//             </h2>
//             <div className=" bg_gray2 rounded p-2">
//               <img
//                 src={responseFileData[itm]}
//                 loading="lazy"
//                 className="w-100 rounded object_fit_contain UploadSignExtractImg"
//               />
//             </div>
//           </div>
//           <h3 className="font_13 mb-0 pt-3 text-center">
//             upload a file?
//             <label className="text_master2 ms-1">
//               Click here
//               <input type="file" className="d-none" 
//               onChange={(e) => handleFileUpload(e,itm)}/>
//             </label>
//           </h3>
//         </div>
//         </div>
//         </div>
//             ))
//            }

//             {/* <div  className="col-12 col-sm-6 br_1">
//               <div className="bg_gray2 d-flex w-100 rounded signatureCrop">
//                 <div className=" m-auto">
//                   <h2 className="font_13 font_600 text-center mb-3">
//                     Please upload a document
//                   </h2>
//                   <div className="d-flex align-items-center justify-content-center">
//                     <label className="UploadLabel bg_master_gradient px-5 py-2 font_12 font_600 text-white border outline rounded-pillbg_master_gradient px-5 py-2 font_12 font_600 text-white border outline rounded-pill cursor-pointer">
//                       Upload
//                       <input
//                         accept={".jpeg,.jpg,.png"}
//                         type="file"
//                         className="d-none"
//                         onChange={(e) => handleFileUpload(e)}
//                       />
//                     </label>
//                   </div>
//                 </div>
//               </div>
//               <div className="d-none">
//                 <div className="row">
//                   <div className="col-12 col-sm-6">
//                     <h2 className="py-2 py-sm-3 mb-0 text-uppercase font_13 fw-bold ws_nowrp text_master2 text-center">
//                       UPLOADED DATA
//                     </h2>
//                     <div className=" bg_gray2 rounded p-2">
//                       <img
//                         src={img2}
//                         className="w-100 rounded object_fit_contain UploadSignImg"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-12 col-sm-6">
//                     <h2 className="py-2 py-sm-3 mb-0 text-uppercase font_13 fw-bold ws_nowrp text_master2 text-center">
//                       EXTRACTED SIGNATURE
//                     </h2>
//                     <div className=" bg_gray2 rounded p-2">
//                       <img
//                         src={img3}
//                         className="w-100 rounded object_fit_contain UploadSignExtractImg"
//                       />
//                     </div>
//                   </div>
//                   <h3 className="font_13 mb-0 pt-3 text-center">
//                     upload a file?
//                     <label className="text_master2 ms-1">
//                       Click here
//                       <input type="file" className="d-none" />
//                     </label>
//                   </h3>
//                 </div>
//               </div>
//             </div> */}

//             <div className={`col-12 text-center mt-3 ${Object.values(uploadFileData).some((itm)=>itm)}`}>
//               <button className="btn btn-master px-3 px-md-5 rounded-pill" onClick={handleMatchScore}>Match Score</button>
//             </div>
//         </div>
//       </div>
//       </div>
//       <div className={`${responseFileData?.matchScore ? "":"d-none"} `}>
//         <div className="w-100 mb-2 bg_gray2 mt-4 p-4 match_score">
//           <h2 className="text-black font_14 fw_600 text-center">
//             SIGNATURE MATCH SCORE
//           </h2>
//          { responseFileData?.matchScore?.msg?.split(",").map((itm)=>(
//           // //console.log(itm),
//           <h4 className="fw_600 font_40 text_master2 text-center mb-0">{itm}</h4>
//          ))}
//         </div>
//       </div> 
//       </div>


//       <div className="SignatureMaster  bg-white w-100 overflow-auto scrollbar1 d-none">
//         <div className="border border-2 bd_gray2 ms-0 p-3  rounded ">
//           <div className="row gap-2 gap-sm-0">


//             <div className="col-md-6">

//             </div>


//             <div className="col-md-6">

//             </div>



//           </div>
//         </div>
//         <div className="w-100 bg_gray2 mt-4 p-4">
//           <h2 className="text-black font_14 fw_600 text-center">
//             SIGNATURE MATCH SCORE
//           </h2>
//           <h4 className="fw_600 font_40 text_master2 text-center mb-0">0.84</h4>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SignatureCrop;

// NEW UI FOR SIGNATURE CROP

import { Upload } from '@arco-design/web-react'
import { IconPlus } from '@arco-design/web-react/icon';
import React, { useState } from 'react'
import { getBase64, getLocalStorage, userValidation } from '../../Functions/Utils';
import { ManageApis } from '../../AppServices/ManageApi';
import MenuContainer from '../../Components/MenuContainer/MenuContainer';
import Logo from "../../assets/images/pixl_logo_black 1.png";
import { useStoreValues } from '../../Context/storeProvider';
import { Dropdown } from 'react-bootstrap';
import PopupModal from '../../Components/ModalComponent/PopupModal';
import InputComponent2 from '../../Components/InputComponent/InputComponent2';
import HeaderSection from '../../Components/HeaderSection';


function SignatureCrops(headerName, isToggled, setisToggled) {
  const { user } = useStoreValues();

  const [file, setFile] = React.useState();
  const cs = `arco-upload-list-item${file && file.status === 'error' ? ' is-error' : ''}`;

  // const [visible, setvisible] = useState({ show: false, type: "" });
  // const [errors, setErrors] = useState({});

  const [isLoading, setisLoading] = useState(false);
  const [uploadFileData, setUploadFileData] = useState({
    primaryFile: "",
    secondryFile: "",
  });
  const [responseFileData, setResponseFileData] = useState({
    primaryFile: "",
    secondryFile: "",
    matchScore: ""
  });
  // const handleError = (error, input) => {
  //   setErrors((prevState) => ({ ...prevState, [input]: error }));
  // };
  // const [changePasswordData, setChangePasswordData] = useState({
  //   current_password: "",
  //   new_password: "",
  //   confirm_password: "",

  // });
  // let chnagepasswordForm = [

  //   {
  //     type: "password",
  //     name: "current_password",
  //     label: "Current Password",
  //     isDisabled: false,
  //     error: "",
  //     value: changePasswordData.current_password,
  //   },
  //   {
  //     type: "password",
  //     name: "new_password",
  //     label: "New Password",
  //     isDisabled: false,
  //     error: "",
  //     value: changePasswordData.new_password,
  //   },
  //   {
  //     type: "password",
  //     name: "confirm_password",
  //     label: "Confirm Password",
  //     isDisabled: false,
  //     error: "",
  //     value: changePasswordData.confirm_password,
  //   },
  // ];

  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [showAlert, setShowAlert] = useState(AlertinitialValue);

  let headers = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Key: "aasdapld7!!458856akspksiklsjj-sklsp@#sjkdkldi",
    },
  };

  // const handleLogout = () => {

  //   setisLoading(true)
  //   localStorage.clear()
  //   window.location.href = '/'
  // }

  const handleMatchScore = async () => {
    try {
      setisLoading(true);
      const rqstData = {
        image1: {
          image: responseFileData?.primaryFile,
          image_format: "png",
          image_uuid: 123
        },
        image2: {
          image: responseFileData.secondryFile,
          image_format: "png",
          image_uuid: 123
        }
      }

      let response = await ManageApis(
        "post",
        global.signVerify + global.verifySign,
        rqstData,
        headers
      );

      if (response.message === "Success") {
        // //console.log(response.response_data)

        setResponseFileData((prevData) => ({
          ...prevData,
          matchScore: response?.response_data,
        }));


        setisLoading(false);
      } else {
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "Something went wrong...!",
          isSuccess: false,
          isfalse: true,
        }));
        // //console.log(response);
        setisLoading(false);
      }

    } catch (err) {
      setisLoading(false);
      // console.error(err);
    }
  }
  async function getCropSignatue(base64, fileType) {
    let response = null;
    try {

      var reqstDta = {
        image: {
          image: base64,
          image_format: fileType,
          image_uuid: "123",
        },
        output_option: {
          output_option: "signatures",
        },
      };
      response = await ManageApis(
        "post",
        global.signVerify + global.detectSign,
        reqstDta,
        headers
      );
    } catch (err) {
      // console.error(err);
    }

    return response;
  }
  // const handleChangePassword = async () => {

  //   const validate = () => {
  //     let isValid = true;

  //     let array = Object.keys(changePasswordData);
  //     let result = userValidation(changePasswordData, array);

  //     result.forEach((item) => {

  //       handleError(`Please fill the ${item.replace("_", " ")}`, item);
  //       isValid = false;

  //     });

  //     array.forEach((element) => {
  //       if (changePasswordData[element].length < 5) {

  //         handleError(`Must have minimum length of 5 `, element);
  //         isValid = false;
  //       } else {
  //         handleError(null, element);
  //         isValid = true;
  //       }

  //     });

  //     // //console.log(result);

  //     Object.keys(errors).forEach((key) => {
  //       if (errors[key]) {
  //         isValid = false;
  //         // //console.log(errors[key]);
  //       }
  //     });

  //     return isValid;
  //   };
  //   try {
  //     if (validate()) {
  //       setisLoading(true);
  //       setvisible((pre) => ({
  //         show: false,
  //         type: "",
  //       }));
  //       const reqstBody = {
  //         id: getLocalStorage("clientId"),
  //         emailId: getLocalStorage("email"),
  //         currentPassword: changePasswordData.current_password,
  //         newPassword: changePasswordData.new_password,
  //         confirmNewPassword: changePasswordData.confirm_password,
  //       };
  //       let result = await ManageApis(
  //         "post",
  //         global.changePassword,
  //         reqstBody
  //       );
  //       if (result.message === "Success") {
  //         // //console.log(result);
  //         if (result?.response_data == "Password changed successfully.") {
  //           setChangePasswordData((pre) => ({

  //             confirm_password: "",
  //             current_password: "",
  //             new_password: "",
  //           }));
  //           setShowAlert((pre) => ({
  //             ...pre,
  //             show: true,
  //             message: result.response_data,
  //             isSuccess: true,
  //           }));
  //           setisLoading(false);
  //         }
  //         else {
  //           setChangePasswordData((pre) => ({

  //             confirm_password: "",
  //             current_password: "",
  //             new_password: "",
  //           }));
  //           setShowAlert((pre) => ({
  //             ...pre,
  //             show: true,
  //             message: result.response_data,
  //             isSuccess: false,
  //             isWarning: true,
  //           }));
  //           setisLoading(false);
  //         }
  //         // alert("Password changed successfully.");
  //       } else {
  //         setChangePasswordData((pre) => ({

  //           confirm_password: "",
  //           current_password: "",
  //           new_password: "",
  //         }));
  //         setisLoading(false);
  //         // //console.log(result);
  //         setvisible((pre) => ({
  //           show: false,
  //           type: "",
  //         }));
  //         setShowAlert((pre) => ({
  //           ...pre,
  //           show: true,
  //           message: result?.response_data?.title,
  //           isSuccess: false,
  //           isfalse: true,
  //         }));
  //       }
  //     }

  //   } catch (err) {
  //     // //console.log(err);
  //   }
  // }
  // const handleChange = (e, type) => {
  //   const { name, value } = e.target;
  //   // //console.log(name, value, type);

  //   // ""
  //   switch (name) {
  //     case "current_password":
  //       // ""
  //       setChangePasswordData((prevState) => ({
  //         ...prevState,
  //         [name]: value.slice(0, 12).replace(" ", "").trim(),
  //       })); //maxlength 12
  //       if (!value) {
  //         handleError("Please enter current password", name);
  //       }
  //       if (
  //         changePasswordData.new_password &&
  //         value === changePasswordData.new_password
  //       ) {
  //         handleError("current password can't be same as new password", name);
  //       } else {
  //         handleError(null, name);

  //         handleError(null, "new_password");
  //       }



  //       break;
  //     case "new_password":
  //       // ""
  //       setChangePasswordData((prevState) => ({
  //         ...prevState,
  //         new_password: value.slice(0, 12).replace(" ", "").trim(),
  //       })); //maxlength 12
  //       if (
  //         changePasswordData.confirm_password &&
  //         value !== changePasswordData.confirm_password
  //       ) {
  //         handleError("Passwords do not match", name);
  //       }
  //       else if (
  //         changePasswordData.current_password &&
  //         value === changePasswordData.current_password
  //       ) {
  //         handleError("new password can't be same as current password", name);
  //       }
  //       else {
  //         handleError(null, name);
  //         handleError(null, "confirm_password");
  //         handleError(null, "current_password");
  //       }

  //       break;
  //     case "confirm_password":
  //       setChangePasswordData((prevState) => ({
  //         ...prevState,
  //         [name]: value.slice(0, 12).replace(" ", "").trim(),
  //       })); //maxlength 12
  //       if (
  //         changePasswordData.new_password &&
  //         changePasswordData.new_password !== value
  //       ) {
  //         handleError("Passwords do not match", name);
  //       } else {
  //         handleError(null, name);
  //         handleError(null, "new_password");
  //       }

  //       break;


  //     default:
  //       break;
  //   }

  // };

  const handleFileUpload = async (event, type) => {
    // ""
    setisLoading(true);
    // const file = event.target.files[0];
    const file = event[0].originFile;
    const imgtype = file?.type?.split("/").pop();
    // if (!file) return console.error("No file selected.");
    if (event[0].status == "uploading") {
      try {
        const base64Data = await getBase64(file);
        if (type === "primaryFile") {
          setUploadFileData((prevData) => ({
            ...prevData,
            primaryFile: base64Data,
          }));
          let result = await getCropSignatue(base64Data, imgtype);
          if (result.message == "Success") {
            setResponseFileData((prevData) => ({
              ...prevData,
              primaryFile: result.response_data?.response,
            }));
            setisLoading(false);
          } else {
            // //console.log(result);
            setisLoading(false);
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: result.message,
              isSuccess: false,
              isfalse: true,
            }));
          }
        } else if (type === "secondryFile") {
          setUploadFileData((prevData) => ({
            ...prevData,
            secondryFile: base64Data,
          }));
          let result = await getCropSignatue(base64Data, imgtype);
          if (result.message == "Success") {
            setResponseFileData((prevData) => ({
              ...prevData,
              secondryFile: result.response_data?.response,
            }));

            setisLoading(false);
          } else {
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: result.message,
              isSuccess: false,
              isfalse: true,
            }));
            // //console.log(result);
            setisLoading(false);
          }
        } else {
          // console.error("Invalid file type.");
          setisLoading(false);
        }
      } catch (error) {
        setisLoading(false);
        // console.error("Error converting file to base64:", error);
      }
    }
  };

  return (
    <>
      {/* <header className='px-3 py-3'>
        <div className='align-items-center d-flex justify-content-between'>
          {/* <div>
            Signature Crop
          </div> 
          <div className='align-items-center d-flex'>
            {user}
            <div className='bg-white p-1 rounded-pill'>
              <Dropdown>
                <Dropdown.Toggle variant="unset" className="">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M18 6C19.5913 6 21.1174 6.63214 22.2426 7.75736C23.3679 8.88258 24 10.4087 24 12C24 13.5913 23.3679 15.1174 22.2426 16.2426C21.1174 17.3679 19.5913 18 18 18C16.4087 18 14.8826 17.3679 13.7574 16.2426C12.6321 15.1174 12 13.5913 12 12C12 10.4087 12.6321 8.88258 13.7574 7.75736C14.8826 6.63214 16.4087 6 18 6ZM18 21C24.63 21 30 23.685 30 27V30H6V27C6 23.685 11.37 21 18 21Z" fill="#1A82E2" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu className="NotifMenu">
                  <div className={`zi_1  br_5 border bg-white `}>
                    <div className="d-flex flex-column text-black">
                      <div className="border-bottom d-flex" onClick={() => setvisible((pre) => ({ show: true }))}>
                        <span className="px-3 ps-2 py-3 font_14 font_500  px_hover_1 cursor-pointer w-100">Change password</span>
                      </div>
                      <div className="border-bottom d-flex">
                        <span className="px-3 ps-2 py-3 font_14 font_500 px_hover_1 cursor-pointer w-100" onClick={handleLogout}>Log out</span>
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </header >
      <PopupModal
        title=""
        size="md"
        visible={visible.show}
        handleClose={() => {
          setvisible((prv) => ({ show: false, type: "" })); setChangePasswordData((pre) => ({
            confirm_password: "",
            current_password: "",
            new_password: "",
          })); setErrors({})
        }}
      >
        <div className="row">
          {chnagepasswordForm.map((itm, index) => (
            <div
              key={index}
              className={`${itm.hasOwnProperty("col") ? itm.col : "col-12"}`}
            >
              <InputComponent2
                label={itm.label}
                name={itm.name}
                type={itm.type}
                value={changePasswordData[itm.name]}
                error={errors[itm.name]}
                disabled={itm.isDisabled}
                onchange={(e) => handleChange(e, visible.type)}
              />
            </div>
          ))}

          <div className=" d-flex justify-content-end">
            <button
              className="btn btn-master px-3 font_14"
              onClick={handleChangePassword}
            >
              Submit
            </button>
          </div>
        </div>
      </PopupModal>
 */}
      <HeaderSection />

      <div className='main__section bg-white shadow_sm4 overflow-hidden mt-4 w-100  br_15'>
        <div className='d-block d-md-flex'>
          <div className='reader__right w-100 pt-3 pt-md-0'>
            <div className='bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2'>
              <div className='bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-5'>
                {/* uploaded section- */}
                <div className={`align-items-center ${responseFileData.primaryFile == "" ? "d-none" : ""} rounded  gap-2`}>
                  <h2 className="font_16 fw-bold text-center mt-2 mb-2">Uploaded data</h2>
                  <div className="bg_lightdark upload_thumb object_fit_contain w-100   p-1 br_15">
                    <img src={responseFileData.primaryFile} className=" object_fit_contain w-100 h-100  p-3" />
                  </div>
                  <div className='arco_custom_upload text-center'>
                    <Upload onChange={(e) => { handleFileUpload(e, "primaryFile") }}>
                      <div className={cs}>

                        <div className='bg_master2 px-4 br_5  py-2'>
                          <div className='acro_custom_icon d-flex align-items-center justify-content-center'>
                            {/* <IconPlus /> */}
                            <div className='text-white ms-2'>Try another file</div>
                          </div>
                        </div>

                      </div>
                    </Upload>
                  </div>
                </div>
                {/* uploading section- */}
                <div className={`py-2 py-md-5 align-items-center ${responseFileData.primaryFile == "" ? "" : "d-none"} d-flex flex-column h-100 justify-content-center`}>
                  <div className='mb-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="142" height="161" viewBox="0 0 142 161" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.11401 51.5707C8.11401 49.4107 9.86504 47.6597 12.025 47.6597H54.109C56.269 47.6597 58.02 49.4107 58.02 51.5707V67.1465H137.06C139.512 67.1465 141.5 69.1341 141.5 71.586V156.395C141.5 158.847 139.512 160.835 137.06 160.835H12.5536C10.1017 160.835 8.11407 158.847 8.11407 156.395V81.9422L8.11401 81.9213V51.5707Z" fill="#004C92" />
                      <rect x="23.2548" y="0.165405" width="113.103" height="128.43" fill="#F6F6F6" />
                      <rect x="31.9755" y="9.15018" width="95.6616" height="5.18445" fill="#E4E4E4" />
                      <rect x="31.9755" y="26.5912" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="35.576" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="44.5608" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="53.5456" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="62.5304" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="71.5152" width="95.6616" height="4.22814" fill="#F6F6F6" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 60.6278C0 58.4678 1.75103 56.7167 3.91103 56.7167H46.0338C48.1938 56.7167 49.9449 58.4678 49.9449 60.6278L49.9449 68.3442V71.6474C49.9449 72.9887 50.6252 75.3802 53.1056 76.0077H129.54C131.991 76.0077 133.979 77.9953 133.979 80.4472V156.395C133.979 158.847 131.991 160.835 129.54 160.835H4.43955C1.98766 160.835 0 158.847 0 156.395V90.5947V80.4472V60.6278Z" fill="#1A82E2" />
                      <g filter="url(#filter0_d_64_936)">
                        <path d="M69.1156 132.559H65.6563V111.803L56.1429 121.316L53.6868 118.86L67.386 105.161L81.0851 118.86L78.629 121.316L69.1156 111.803V132.559Z" fill="white" />
                      </g>
                      <defs>
                        <filter id="filter0_d_64_936" x="51.5727" y="105.161" width="31.6265" height="31.6265" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                          <feOffset dy="2.11407" />
                          <feGaussianBlur stdDeviation="1.05703" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_64_936" />
                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_64_936" result="shape" />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                  <h2 className='font_15 fw-light pt-3 mb-2'>This model is ready to extract data!</h2>
                  <h3 className='text_master2 font_15 pt-2 mb-0'>Click to add files you want to process </h3>
                  <div className='text-center w-100'>
                    <div className='arco_custom_upload'>
                      <Upload onChange={(e) => { handleFileUpload(e, "primaryFile") }}>
                        <div className={cs}>

                          <div className='bg_master2 px-4 br_5  py-2'>
                            <div className='acro_custom_icon d-flex align-items-center justify-content-center'>
                              <IconPlus />
                              <div className='text-white ms-2'>Upload files</div>
                            </div>
                          </div>

                        </div>
                      </Upload>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-7">
                <div className={`align-items-center ${responseFileData.secondryFile == "" ? "d-none" : ""} rounded  gap-2`}>
                  <h2 className="font_16 fw-bold text-center mt-2 mb-2">Uploaded data</h2>
                  <div className="bg_lightdark upload_thumb object_fit_contain w-100   p-1 br_15">
                    <img src={responseFileData.secondryFile} className=" object_fit_contain w-100 h-100  p-3" />
                  </div>
                  <div className='arco_custom_upload text-center'>
                    <Upload onChange={(e) => { handleFileUpload(e, "secondryFile") }}>
                      <div className={cs}>

                        <div className='bg_master2 px-4 br_5  py-2'>
                          <div className='acro_custom_icon d-flex align-items-center justify-content-center'>
                            {/* <IconPlus /> */}
                            <div className='text-white ms-2'>Upload files</div>
                          </div>
                        </div>

                      </div>
                    </Upload>
                  </div>
                </div>
                {/* uploading section- */}
                <div className={`py-2 py-md-5 align-items-center ${responseFileData.primaryFile == "" ? "" : "d-none"} d-flex flex-column h-100 justify-content-center`}>
                  <div className='mb-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="142" height="161" viewBox="0 0 142 161" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.11401 51.5707C8.11401 49.4107 9.86504 47.6597 12.025 47.6597H54.109C56.269 47.6597 58.02 49.4107 58.02 51.5707V67.1465H137.06C139.512 67.1465 141.5 69.1341 141.5 71.586V156.395C141.5 158.847 139.512 160.835 137.06 160.835H12.5536C10.1017 160.835 8.11407 158.847 8.11407 156.395V81.9422L8.11401 81.9213V51.5707Z" fill="#004C92" />
                      <rect x="23.2548" y="0.165405" width="113.103" height="128.43" fill="#F6F6F6" />
                      <rect x="31.9755" y="9.15018" width="95.6616" height="5.18445" fill="#E4E4E4" />
                      <rect x="31.9755" y="26.5912" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="35.576" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="44.5608" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="53.5456" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="62.5304" width="95.6616" height="4.22814" fill="#E4E4E4" />
                      <rect x="31.9755" y="71.5152" width="95.6616" height="4.22814" fill="#F6F6F6" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 60.6278C0 58.4678 1.75103 56.7167 3.91103 56.7167H46.0338C48.1938 56.7167 49.9449 58.4678 49.9449 60.6278L49.9449 68.3442V71.6474C49.9449 72.9887 50.6252 75.3802 53.1056 76.0077H129.54C131.991 76.0077 133.979 77.9953 133.979 80.4472V156.395C133.979 158.847 131.991 160.835 129.54 160.835H4.43955C1.98766 160.835 0 158.847 0 156.395V90.5947V80.4472V60.6278Z" fill="#1A82E2" />
                      <g filter="url(#filter0_d_64_936)">
                        <path d="M69.1156 132.559H65.6563V111.803L56.1429 121.316L53.6868 118.86L67.386 105.161L81.0851 118.86L78.629 121.316L69.1156 111.803V132.559Z" fill="white" />
                      </g>
                      <defs>
                        <filter id="filter0_d_64_936" x="51.5727" y="105.161" width="31.6265" height="31.6265" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                          <feOffset dy="2.11407" />
                          <feGaussianBlur stdDeviation="1.05703" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_64_936" />
                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_64_936" result="shape" />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                  <h2 className='font_15 fw-light pt-3 mb-2'>This model is ready to extract data!</h2>
                  <h3 className='text_master2 font_15 pt-2 mb-0'>Click to add files you want to process </h3>
                  <div className='text-center w-100'>
                    <div className='arco_custom_upload'>
                      <Upload onChange={(e) => { handleFileUpload(e, "secondryFile") }}>
                        <div className={cs}>

                          <div className='bg_master2 px-4 br_5  py-2'>
                            <div className='acro_custom_icon d-flex align-items-center justify-content-center'>
                              <IconPlus />
                              <div className='text-white ms-2'>Upload files</div>
                            </div>
                          </div>

                        </div>
                      </Upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='d-flex mt-5'>
        <div className='bg_light4 m-auto px-3 py-2 br_10'>
          <p className='text-black d-flex mb-0 align-items-center fw_500'>Signature match score is <span className='ms-2 font_40 fw_600 text-success'>0.84</span></p>
        </div>
      </div>
    </>

  )
}

export default SignatureCrops